module.exports = __webpack_public_path__ + "img/bum(2).c2f9dfc5.png";